(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ElcServiceBus"), require("HypoContainer"), require("mobx"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["ElcServiceBus", "HypoContainer", "mobx", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("ElcServiceBus"), require("HypoContainer"), require("mobx"), require("react")) : factory(root["ElcServiceBus"], root["ElcRuntime"]["HypoContainer"], root["ElcRuntime"]["mobx"], root["ElcRuntime"]["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE_elc_service_bus__, __WEBPACK_EXTERNAL_MODULE_hypo_container__, __WEBPACK_EXTERNAL_MODULE_mobx__, __WEBPACK_EXTERNAL_MODULE_react__) {
return 